import Assets from "../imports/assets.import";

export interface storeAction {
  type: string;
  payload: object | object[];
}
export interface IDropdownData {
  label: string;
  value: string;
}
export interface IObject {
  [key: string]: any;
}
export interface IModal {
  openModal: Function;
  closeModal: Function;
}

export interface IFileUpload {
  openUpload: Function;
}

export interface IResponseList {
  status: string;
  success: string;
  data: IObject;
}

export interface IResponseData {
  status?: string;
  success?: string;
  message?: string;
  data: IObject;
}

export enum BOOLEAN {
  TRUE = "true",
  FALSE = "false",
}

export enum ButtonTypes {
  PRIMARY = "PRIMARY",
  PRIMARY_GRADIENT = "PRIMARY_GRADIENT",
  TERTIARY = "TERTIARY",
  SECONDARY = "SECONDARY",
  OUTLINED = "OUTLINED",
  TEXT = "TEXT",
  DISABLED = "DISABLED",
  TEXT_UNDERLINE = "TEXT_UNDERLINE"
}

export enum ButtonSize {
  SMALL = "Small",
  MEDIUM = "Medium",
  LARGE = "Large",
}

export enum InputTypes {
  LINE = "LINE",
  OTP = "OTP",
  EDITOR = "EDITOR",
  COLOR_PICKER = "COLOR_PICKER",
}
export interface IMenuItem {
  title: string;
  onPress: Function;
  className?: string;
  type?: string;
}

export enum ORIENTATION {
  PORTRAIT = 'portrait',
  LANDSCAPE = "landscape"
}

export interface IComments {
  _id: String;
  x: number;
  y: number;
  z: number;
  created_at?: string;
  modified_at?: string;
  message: string
}

export enum FormatTypes {
  LANDSCAPE = "landscape",
  PORTRAIT = "portrait"
}

export interface UserState {
  currentUser: {
    _id: string | null,
    email: string | null,
    name: string | null,
  }
}

export interface Project {
  project_id: string;
  project_name: string;
}
export interface ProjectState {
  currentProject: Project | null;
}
export interface TargetImageObject {
  id:string,
  type:string,
  properties:IObject,
  // Author-given or generated name ("Text 2"); older saved objects have none and get a derived one.
  name?: string,
}

export interface TargetImageData {
  id: string,
  // Author-given or generated name ("Target 1"); older saved targets have none and fall back to their position.
  name?: string,
  targetImage: string | null,
  targetId: string | null,
  selectedTargetImageDimension: { width: number, height: number },
  containedTargetImageDimension: { width: number, height: number },
  objects:Array<TargetImageObject>,
  // PAYMENT.md Phase 4 -- surfaced by get_many_project_data so the editor can disable image/video
  // replacement on a target once it's paid for, without a separate per-target status call.
  isPaid?: boolean,
  isLocked?: boolean,
  // The project_data row id backing this target, so per-target edits (e.g. removing a deleted
  // object) can be persisted via edit_project_data instead of only updating Redux state.
  projectDataId?: string,
}
export interface EditorState {
  targetImageDataList: Array<TargetImageData>,
  currentSelectedPropertyType: PropertiesTypes | null,
  selectedTargetIndex: number | null,
  selectedTargetImageID: string | null,
  selectedObjectID: string | null,
  selectedTransformControl:TransformType | null,
  // Set when an object is picked by clicking it (canvas or Objects list): the workspace then keeps the
  // tool in use and shows the box, instead of clearing the tool as it does for any other selection.
  keepToolForObjectID: string | null,
  zoomPercentage:number,
  lastDeletedTargetImageData: TargetImageData | null,
  isTargetImageListItemClicked: boolean,
  isObjectListItemClicked: boolean,
  isUpdatingFromEditorWorkspace: boolean,
  shouldUpdateObjectState: boolean,
  history: Array<Array<TargetImageData>>,
  future: Array<Array<TargetImageData>>,
  isGestureInProgress: boolean,
  hasUnsavedChanges: boolean,
}

export enum UploadFileTypes {
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
}

export enum PropertiesTypes {
  TARGET = "target",
  TEXT = "text",
  IMAGE = "image",
  BUTTON = "button",
  VIDEO = "video",
  SOCIAL = "social",
}

export enum ObjectTypes {
  IMAGE = "image",
  TEXT = "text",
  BUTTON = "button",
  VIDEO = "video",
  SOCIAL = "social",
}

// The same line icons as the "Add an object" dialog (PICPOP Editor design, page 7), so a type looks alike everywhere.
export const ObjectTypesImages: Record<ObjectTypes,string> = {
  [ObjectTypes.IMAGE]: Assets.choose_image,
  [ObjectTypes.TEXT]: Assets.choose_text,
  [ObjectTypes.BUTTON]: Assets.choose_button,
  [ObjectTypes.VIDEO]: Assets.choose_video,
  [ObjectTypes.SOCIAL]: Assets.choose_social,
}

export const ObjectTypesImagesActive: Record<ObjectTypes,string> = {
  [ObjectTypes.IMAGE]: Assets.object_image_active,
  [ObjectTypes.TEXT]: Assets.object_text_active,
  [ObjectTypes.BUTTON]: Assets.object_button_active,
  [ObjectTypes.VIDEO]: Assets.object_video_active,
  [ObjectTypes.SOCIAL]: Assets.object_social_active,
}


export enum ColorPickerTypes {
  SKETCH = "SKETCH",
  TWITTER = "TWITTER",
}

export enum FontFamilyTypes {
  MONTSERRAT = "Montserrat",
  OPEN_SANS = "OpenSans",
  FUNNEL_SANS = "FunnelSans",
  IBM_PLEX_SERIF = "IBMPlexSerif",
  SPECTRAL = "Spectral",
  ROBOTO = "Roboto",
  POPPINS = "Poppins",
  RUBIK = "Rubik",
  TINOS = "Tinos",
}

export enum ButtonStyles {
  PRIMARY_WITH_BORDER_RADIUS = "ButtonPrimaryWithBorderRad",
  TEXT_WITH_UNDERLINE = "ButtonTextWithUnderline",
  OUTLINED_WITH_BORDER_RADIUS = "ButtonOutlinedWithBorderRad",
  PRIMARY_WITHOUT_BORDER_RADIUS = "ButtonPrimaryWithoutBorderRad",
  SECONDARY_WITH_BORDER_RADIUS = "ButtonSecondaryWithBorderRad",
  OUTLINED_WITHOUT_BORDER_RADIUS = "ButtonOutlinedWithoutBorderRad",
}

export enum FontStyles {
  BOLD = "bold",
  ITALIC = "italic",
  UNDERLINE = "underline",
}

export enum TransformType {
  POSITION = 'position',
  ROTATION = 'rotation',
  SCALE = 'scale'
}

export enum SortTypes {
  ALL = "",
  Data_Ascending = "Data Ascending",
  Data_Descending = "Data Descending",
  Last_Modified = "Last Modified",
}

export enum ProjectStatus {
  PUBLISHED = 'published',
  UN_PUBLISHED = 'unpublished'
}

export enum AccountSettingsTabs {
  PROFILE = 'Profile',
  CHANGE_PASSWORD = 'Password',
  MY_BILLS = 'Plan & bills',
  SUPPORT = 'Support'
}

export enum Status {
  SUCCESS = "success",
  FAILED = 'failed',
}

export enum GoogleAuthMethod {
  SIGNUP = "signup",
  LOGIN = "login",
}

export interface IImageTargetResources {
  originalImage: string;
  croppedImage: string;
  thumbnailImage: string;
  luminanceImage: string;
}

export interface UploadObjectData {
  _id: string;
  project_id: string;
  target_id: string;
  image?: string;
  video?: string;
  size_bytes: number;
  mime_type: string;
  sha256: string;
}

export interface IImageTargetManifest {
  type: "PLANAR";
  properties: IObject;
  imagePath: string;
  metadata: { targetImageId: string } | null;
  name: string;
  resources: IImageTargetResources;
  created: number;
  updated: number;
  target_id: string;
}

// PAYMENT.md Phase 5 -- shape of GET /target/resolve/:target_id's `data`.
export interface ITargetResolveData {
  expired: boolean;
  expires_at: string | null;
  target?: Record<string, unknown>;
  objects?: Record<string, unknown>[];
}

export interface IExpiryStatus {
  label: 'No expiry' | 'Active' | 'Expiring soon' | 'Expired';
  isExpired: boolean;
  isExpiringSoon: boolean;
  daysRemaining: number | null;
}